// Resolves the `collection-spotlight-enabled` flag via `useAsyncData` so it's resolved on
// the server before first paint (no post-hydration flash) without forcing callers to be
// async — they read the returned `ComputedRef<boolean>` synchronously.
export const useSpotlightFlag = () => {
  const { getFlag } = useFeatureFlags();

  const { data } = useAsyncData(
    'collection-spotlight-enabled',
    () => getFlag('collection-spotlight-enabled'),
  );

  return computed(() => data.value ?? false);
};
